import { definePlugin } from '@dundle/utils/nuxt';

export default definePlugin(({ app, store, env, redirect }, inject) => {
    inject('redirect', {
        toFacebookMessenger() {
            window.open('http://m.me/DundleCom');
        },
    });
});
